export const ltLT = {
  app: {
    categories: {
      convectors: 'Konvektoriai',
      decorative: 'Dekoratyviniai',
      electric: 'Elektriniai',
      panels: 'Paneliniai',
      towel: 'Rankšluosčių džiovintuvai',
    },
    categoryLabel: 'Kategorija',
    categoryPlaceholder: 'Pasirinkite kategoriją',
    errorCategories: 'Nepavyko gauti kategorijų.',
    errorPanels: 'Nepavyko gauti radiatorių.',
    loadingCategories: 'Kraunamos kategorijos...',
    loadingPanels: 'Kraunami radiatoriai...',
    panelLabel: 'Radiatoriai',
    panelPlaceholder: 'Pasirinkite radiatorių',
    titles: {
      convectors: 'Konvektorių skaičiuoklė',
      decorative: 'Dizaininių radiatorių skaičiuoklė',
      electric: 'Elektrinių radiatorių skaičiuoklė',
      panels: 'Panelinių radiatorių skaičiuoklė',
      towel: 'Rankšluosčių džiovintuvų skaičiuoklė',
    },
  },
  calc: {
    actionButton: 'Rodyti apskaičiuotus straipsnius',
    boost: 'Pažangus režimas',
    calculateRequiredButton: 'Skaičiuoti šilumos poreikį',
    calculating: 'Skaičiuojama...',
    comfort: 'Komforto režimas',
    downloadLabel: 'Atsisiųsti duomenis ({count})',
    emptyResults: 'Rezultatų nėra.',
    errorMatch: 'Nepavyko apskaičiuoti rezultatų.',
    errorTypes: 'Nepavyko gauti skydelių tipų.',
    flowTemp: 'Tiekimo temperatūra C°',
    height: 'Aukštis',
    length: 'Ilgis',
    loadingTypes: 'Kraunami tipai...',
    modeLabel: 'Režimas',
    modes: {
      cooling: 'Vėsinimas',
      heating: 'Šildymas',
    },
    radiatorType: 'Radiatoriaus tipas',
    requiredWatts: 'Šilumos poreikis (vatai)',
    resultsMessage: '{count} straipsnių pasirinktiems nustatymams.',
    returnTemp: 'Grįžtama temperatūra C°',
    roomTemp: 'Kambario temperatūra C°',
    selectAllLabel: 'Pasirinkti visus straipsnius',
    selectItemLabel: 'Pasirinkti straipsnį atsisiuntimui',
    selectPanel: 'Pasirinkite radiatorių skaičiavimui.',
    standby: 'Budėjimo režimas',
    tableHeaders: {
      calculatedWattage: 'Galia',
      co2Equivalent: 'CO2 ekvivalentas kg medžiagos',
      depth: 'Gylis [mm]',
      description: 'Prekės aprašymas',
      dop: 'DOP',
      eudop: 'EU DOP',
      height: 'Aukštis [mm]',
      itemId: 'Prekės kodas',
      length: 'Ilgis [mm]',
      waterContent: 'Vandens tūris',
      weight: 'Svoris',
    },
    title: 'Skaičiavimai',
    tolerance: 'Tolerancija',
    typeCooling: 'Vėsinimas',
    typeGroupLabel: 'Tipas',
    typeHeating: 'Šildymas',
  },
  existingRadiator: {
    description:
      'Ši skaičiuoklė skirta tik informaciniais tikslais. Prieš pirkdami radiatorių visada pasitarkite su profesionaliu montuotoju, kad gautumėte tikslų skaičiavimą.',
    height: 'Radiatoriaus aukštis',
    length: 'Radiatoriaus ilgis',
    resultLabelTemplate: 'Šilumos galios poreikis, apskaičiuotas su sistemos temperatūra {temp}',
    select: 'Pasirinkti',
    temperature: 'Sistemos temperatūra',
    type: 'Radiatoriaus tipas',
  },
  matrixCalc: {
    axisHeight: 'Aukštis (mm)',
    axisLength: 'Ilgis (mm)',
    axisType: 'Tipas',
    calculateButton: 'Calculate',
    displayLabel: 'Rodymas',
    exportExcel: 'Eksportuoti į „Excel“',
    exportPdf: 'Eksportuoti į PDF',
    print: 'Spausdinti',
    hideOutOfRange: 'Slėpti elementus už intervalo ribų',
    showAll: 'Rodyti viską',
    loading: 'Loading...',
    lockHeight: 'Aukštis',
    lockLabel: 'Užfiksuoti matmenį',
    lockLength: 'Ilgis',
    lockType: 'Tipas',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Skaičiuoti',
    clearButton: 'Išvalyti',
    fields: {
      ceilingHeight: 'Lubų aukštis',
      doorInsulation: 'Durų izoliacija',
      floorInsulation: 'Grindų izoliacija',
      glazingArea: 'Stiklo plotas',
      glazingMode: 'Stiklo plotas',
      glazingQuality: 'Stiklo kokybė',
      length: 'Ilgis',
      outerWalls: 'Išorinės sienos',
      projectedDesignTemp: 'Projektinė lauko temperatūra',
      roofInsulation: 'Stogo izoliacija',
      roomArea: 'Kambario plotas',
      roomFloor: 'Aukštas',
      roomInsulation: 'Kambario izoliacija',
      roomPreset: 'Kambario tipas',
      roomTemperature: 'Kambario temperatūra',
      roomType: 'Kambario tipas',
      uncertaintyFactor: 'Neapibrėžties faktorius',
      ventilation: 'Ventiliacijos lygis',
      wallInsulation: 'Sienų izoliacija',
      width: 'Plotis',
      windConditions: 'Vėjo sąlygos',
      windowInsulation: 'Langų izoliacija',
    },
    intro:
      'Apskaičiuokite kambario šilumos nuostolius, kad galėtumėte pasirinkti tinkamą produktą iš Purmo šildymo įrenginių asortimento.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Daugiau nei 20%',
        low: 'Mažiau nei 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Virš 20%',
        below_10: 'Mažiau nei 10%',
        from_10_to_20: 'Nuo 10% iki 20%',
        no_windows: 'Nėra langų',
      },
      insulationValue: {
        good: 'Geras',
        medium: 'Vidutinis',
        poor: 'Prastas',
        very_good: 'Labai geras',
      },
      qualityValue: {
        modern_excellent: 'Energiją taupantys, trigubas stiklas',
        modern_good: 'Modernūs, sandarūs, su izoliuojančiu stiklu',
        old_poor: 'Seni, susidėvėję, nesandarūs',
        traditional_medium: 'Tradiciniai geros būklės, papildomai sandarinti',
      },
      roomValue: {
        bathroom_24: 'Vonios kambarys (24 C°)',
        bedroom_20: 'Miegamasis (20 C°)',
        garage_12: 'Garažas (12 C°)',
        livingroom_22: 'Svetainė (22 C°)',
        storage_16: 'Sandėliukas (16 C°)',
      },
      select: 'Pasirinkti',
      storeyValue: {
        ground_multi: 'Pirmas aukštas (daugiaaukštis namas)',
        ground_single: 'Pirmas aukštas (vieno aukšto namas)',
        interim: 'Tarpinis aukštas',
        top_multi: 'Viršutinis aukštas (daugiaaukštis namas)',
      },
      temp: {
        climate_zone_1: 'DUT -12 C°',
        climate_zone_2: 'DUT -14 C°',
        climate_zone_3: 'DUT -16 C°',
        climate_zone_4: 'DUT -18 C°',
        climate_zone_5: 'DUT -20 C°',
        climate_zone_6: 'DUT -22 C°',
        climate_zone_7: 'DUT -24 C°',
        climate_zone_8: 'DUT -26 C°',
      },
      windInfluence: {
        normal: 'Įprastos',
        strong: 'Nepalankios',
        weak: 'Palankios',
      },
    },
    roomPresets: {
      bathroom: 'Vonios kambarys',
      bedroom: 'Miegamasis',
      garage: 'Garažas',
      kitchen: 'Virtuvė',
      living: 'Svetainė',
      storage: 'Sandėliukas',
    },
    sections: {
      dimensions: 'Kambario matmenys',
      insulation: 'Izoliacija',
      placement: 'Vieta',
      result: 'Rezultatai',
      temps: 'Temperatūros',
      ventilation: 'Ventiliacija',
    },
    title: 'Šilumos poreikio skaičiuoklė',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Naudoti',
  },
  slider: {
    from: 'Nuo',
    to: 'Iki',
    value: 'Reikšmė',
  },
}
